"use strict";

PF.Entity = class Entity
	{
	static get options()
		{
		return {
			dom: {},
			eventsTrait: PF.Entity.EventsTrait,
			populateOptions: true,
			// dataKeys: {},
		};
		}

	constructor(options = {})
		{
		PF.Options.populate(this, options);
		this.useTrait(this.options.eventsTrait);
		this.init();
		}

	init()
		{
		}

	useTrait(trait, use = true)
		{
		PF.H.useTrait(this, trait, use);
		}

	// clone()
	// 	{
	// 	let clone = Object.create(this.constructor.prototype);
	//
	// 	//скопировать не перечисляемые функции по трэйтам
	// 	for (let traitName in this.traits)
	// 		{
	// 		let trait = this.traits[traitName];
	// 		clone.useTrait(trait.class);
	// 		}
	//
	// 	//скопировать перечисляемые свойства с переопределением сеттера, если он есть
	// 	for (let key in this)
	// 		{
	// 		if (key in this.entityProps)
	// 			{
	// 			Object.defineProperty(clone, key, {
	// 				configurable: true,
	// 				enumerable: true,
	// 				get()
	// 					{
	// 					return clone.entityProps[key];
	// 					},
	// 				set(value)
	// 					{
	// 					clone.setter(key, value);
	// 					}
	// 			});
	// 			}
	// 		else
	// 			{
	// 			clone[key] = this[key];
	// 			}
	// 		}
	//
	// 	//скопировать не перечисляемые свойства по словарю
	// 	let dict = ['entityProps', 'entityEvents', 'entityDelegatedEvents', 'traits'];
	// 	for (let i = 0; i < dict.length; i++)
	// 		{
	// 		Object.defineProperty(clone, dict[i], {
	// 			configurable: true,
	// 			enumerable: false,
	// 			value: this[dict[i]],
	// 		});
	// 		}
	// 	return clone;
	// 	}

	destroy()
		{
		// this.trigger('destroy');
		// this.destroed = true;
		this.off();
		this.dom.destroy();
		}


	// get(path, undefinedValue = undefined, nullValue = null, after = (v) => v)
	// 	{
	// 	return PF.H.get(this, path, undefinedValue, nullValue, after);
	// 	}
	//
	// set(path, value)
	// 	{
	// 	return PF.H.set(this, path, value);
	// 	}

	setData(path, value)
		{
		return PF.H.setData(this, path, value);
		}

	setDataKey(key)
		{
		this.set('dataKeys.' + key, true);
		}

	toJSON()
		{
		let dataKeysIndex = this instanceof PF.Model ? 'options.dataKeys' : 'dataKeys';
		let dataKeys = this.get(dataKeysIndex, {}, {});
		let result = {};
		if(this.get('options.isNull') === true)
			{
			return null;
			}
		for (let key in dataKeys)
			{
			if (PF.H.get(this, key) instanceof PF.Entity || PF.H.get(this, key) instanceof PF.Entity.Array)
				{
				result[key] = PF.H.get(this, key).toJSON();
				}
			else
				{
				result[key] = PF.H.get(this, key);
				}
			}
		return result;
		}

	};
